import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { ThemeProvider, theme } from "@reconvert/react-ui-component";
import { LoggerProvider } from "@reconvert/react-logger";
import {
  ENV,
  DD_CLIENT_TOKEN,
  DD_SERVICE,
  UNLEASH_URL,
  UNLEASH_CLIENT_KEY,
  UNLEASH_REFRESH_INTERVAL,
} from "./config";
import "./index.css";
import App from "./App";
import useFontLoader from "./hooks/useFontLoader";
import { FlagProvider, IConfig } from "@unleash/proxy-client-react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { useDirection } from "./hooks/useDirection";
import { useMemo } from "react";

const config = {
  url: UNLEASH_URL,
  clientKey: UNLEASH_CLIENT_KEY,
  refreshInterval: UNLEASH_REFRESH_INTERVAL,
  appName: "conditions",
};

const options = {
  rtl: { key: "chakra-rtl", stylisPlugins: [rtlPlugin], speedy: true },
  ltr: { key: "chakra-ltr", speedy: true },
};

const AppWrapper = () => {
  const fontLoaded = useFontLoader();
  const { direction } = useDirection();

  const rtlCache = useMemo(() => {
    return createCache(options[direction]);
  }, [direction]);

  console.log({ fontLoaded });

  if (!fontLoaded) {
    return <></>;
  }

  return (
    <FlagProvider config={config as IConfig} startClient={false}>
      <LoggerProvider env={ENV} ddClientToken={DD_CLIENT_TOKEN} ddService={DD_SERVICE} forceLogging>
        <ChakraProvider theme={theme}>
          <CacheProvider value={rtlCache}>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </CacheProvider>
        </ChakraProvider>
      </LoggerProvider>
    </FlagProvider>
  );
};

export default AppWrapper;
